/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { AwsEc2InstanceRestoreDestination } from '../models/AwsEc2InstanceRestoreDestination';
import { RestoreInstanceImageInput } from '../models/RestoreInstanceImageInput';

export class RestoreAwsEc2InstanceRequest {
  /**
  * Eon-assigned ID of the restore account.
  */
  'restoreAccountId': string;
  'destination': AwsEc2InstanceRestoreDestination;
  'image'?: RestoreInstanceImageInput;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "restoreAccountId",
      "baseName": "restoreAccountId",
      "type": "string",
      "format": ""
    },
    {
      "name": "destination",
      "baseName": "destination",
      "type": "AwsEc2InstanceRestoreDestination",
      "format": ""
    },
    {
      "name": "image",
      "baseName": "image",
      "type": "RestoreInstanceImageInput",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return RestoreAwsEc2InstanceRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

